// libs/animation/index.js
import initLoading from "./initLoading";
import initGsapAnimation from "./initGsapAnimation";
import initObserveAnimation from "./initObserveAnimation";

export default function initAnimationScript() {
  return initLoading().then(() => {
    initGsapAnimation();
    initObserveAnimation();
  });
}
